// extracted by mini-css-extract-plugin
export default {"root":"nbXp2dMyXk3xGg7gt7Tm","row":"ZsVZBu7z2hZ7WOhpuNnK","td":"J51dPE9Ept3iNccO9jL7","placeHolderShimmer":"VksvNTk2daJHToXSnr3Q"};